<!--
 * @Author: zhangjingqing
 * @Date: 2022-03-11 23:06:14
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-19 18:59:27
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\layouts\TaxLayout.vue
-->
<template>
  <a-layout style="height: 100%; min-width: 1600px">
    <a-layout-header class="header" @click="hidePanel">
      <img class="logo" :src="require('@/assets/img/m1.png')" alt="" />
      <div class="header-content">
        <div class="left">
          <img :src="require('@/assets/img/p6.png')" alt="" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              {{ tenantInfo.name }} <a-icon type="down" />
            </a>
          </a-dropdown>
        </div>
        <div class="right">
          <!-- 新增操作指南按钮 -->
          <a href="javascript:;" @click="openGuide" class="guide-btn">
            <a-icon type="book" style="margin-right: 8px" />操作指南
          </a>
          <a href="javascript:;" @click="handleLogout">
            <img :src="require('@/assets/img/exit.png')" alt="" />退出
          </a>
          <div class="aizs" @click="openChatIndex">
            <img src="../assets/logo.jpg" alt="" />
            <div>税务</div>
            <div>AI助手</div>
          </div>
        </div>
      </div>
    </a-layout-header>
    <div class="content-cover" @click="hidePanel">
      <a-layout class="content">
        <a-layout-sider width="240" class="aside">
          <div class="tabs">
            <div class="tab" v-for="(item, i) in tabs" :key="item.name">
              <div class="cover" @click="handleTabChange(i, item.route)">
                <div class="img">
                  <img :src="i == active ? item.icon : item.icon1" alt="" />
                </div>
                <div class="title">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="userInfo">
            <div class="cover">
              <div class="avatar">
                <a-avatar :size="120" icon="user" />
              </div>
              <div class="name">{{ userInfo.realname }}</div>
              <div class="dep">{{ tenantInfo.name }}</div>
              <div class="setting">
                <a
                    href="javascript:;"
                    ref="setting"
                    @click="settingVisible = !settingVisible"
                >设置</a
                >
              </div>
            </div>
          </div>
          <div
              class="setting-panel"
              ref="settingPanel"
              @click.stop="settingVisible = true"
              v-if="settingVisible"
          >
            <div class="tip">
              <img :src="require('@/assets/img/tip.png')" alt="" />
            </div>
            <br />
            如需修改请联系客服。
            <a-form
                :form="form"
                :layout="'vertical'"
                style="margin-top: 50px; padding: 0 20px"
            >
              <a-form-item label="会计准则">
                <a-select
                    v-model="fieldInfo.indexStandardType"
                    placeholder="请选择会计准则"
                    :disabled="true"
                >
                  <a-select-option value="0">
                    企业会计准则（2007）
                  </a-select-option>
                  <a-select-option value="1">
                    企业会计准则（2019）
                  </a-select-option>
                  <a-select-option value="2">
                    小企业会计准则（2013）
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="纳税人类型">
                <a-radio-group v-model="fieldInfo.taxpayerNature" :disabled="true">
                  <a-radio value="0"> 一般纳税人 </a-radio>
                  <a-radio value="1"> 小规模企业纳税人 </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-button icon="lock" @click="handleUpdatePsd(userInfo.id)">修改密码</a-button>
            </a-form>
          </div>
        </a-layout-sider>
        <a-layout class="main">
          <div class="cover">
            <router-view />
          </div>
        </a-layout>
      </a-layout>
    </div>
    <password-modal ref="passwordModal"></password-modal>
    <chat-ai :isVisible="chatAiVisible" @close="handleChatAiClose" />

    <!-- 操作指南弹窗 -->
    <a-modal
        title="税务AI助手操作指南"
        v-model="guideVisible"
        width="600px"
        @cancel="guideVisible = false"
        destroyOnClose
    >
      <div class="guide-content">
        <div class="file-item">
          <a
              :href="fileBaseUrl + encodeURIComponent('税务AI助手操作视频.mp4')"
              target="_blank"
              class="file-link"
          >
            税务AI助手操作视频.mp4
          </a>
        </div>
        <div class="file-item">
          <a
              :href="fileBaseUrl + encodeURIComponent('test.pdf')"

              target="_blank"
              class="file-link"
          >
            税务AI助手操作手册.pdf
          </a>
        </div>
        <div class="tips">
          <a-icon type="exclamation-circle" />
          提示：点击文件链接可直接查看/下载操作指南文件
        </div>
      </div>
    </a-modal>
  </a-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PasswordModal from "../views/userManage/user/components/PasswordModal";
import ChatAi from "../views/userManage/user/components/ChatAi";

export default {
  name: "TaxLayout",
  data() {
    return {
      chatAiVisible: false,
      guideVisible: false, // 操作指南弹窗控制
      // Nginx文件访问基础路径（需替换为你的服务器域名/IP）
      fileBaseUrl: "https://new-test.hthuiyou.com/account/files/",
      tabs: [
        {
          name: "数据采集",
          icon: require("@/assets/img/sa1.png"),
          icon1: require("@/assets/img/sa7.png"),
          route: "/taxRiskControl/dataCollect",
        },
        {
          name: "风险检测",
          icon: require("@/assets/img/sa5.png"),
          icon1: require("@/assets/img/sa2.png"),
          route: "/taxRiskControl/riskAnalyse",
        },
      ],
      active: 0,
      settingVisible: false,
      form: {},
    };
  },
  mounted() {
    this.active = this.$route.name == "riskAnalyse" ? 1 : 0;
  },
  methods: {
    // 打开操作指南弹窗
    openGuide() {
      this.guideVisible = true;
    },
    openChatIndex() {
      this.chatAiVisible = true;
      console.log('openChatIndex 方法中 chatAiVisible 的值:', this.chatAiVisible);
    },
    handleChatAiClose() {
      this.chatAiVisible = false;
    },
    ...mapActions(["Logout"]),
    handleLogout() {
      this.Logout();
    },
    handleUpdatePsd(id) {
      this.$refs.passwordModal.show(id);
    },
    handleTabChange(i, route) {
      this.active = i;
      this.$router.push(route);
    },
    hidePanel(e) {
      if (
          e.target != this.$refs.setting &&
          e.target != this.$refs.settingPanel
      ) {
        this.settingVisible = false;
      }
    },
  },
  computed: {
    ...mapGetters(["fieldInfo", "userInfo", "tenantInfo"]),
  },
  components: { PasswordModal, ChatAi },
  watch: {
    $route() {
      this.active = this.$route.name == "riskAnalyse" ? 1 : 0;
    },
  },
};
</script>

<style lang="less" scoped>
@side-width: 240px;

.header {
  height: 60px;
  padding: 0 25px;
  background: #fff;
  box-shadow: 0px 0px 6px #cccccc;
  z-index: 9;
  .logo {
    margin: 13px 28px 14px 0;
    float: left;
  }
  .header-content {
    display: flex;
    justify-content: space-between;
    height: 100%;
    .left {
      img {
        margin-bottom: 4px;
        margin-right: 5px;
      }
      .ant-dropdown-link {
        color: #383838;
      }
    }
    .right {
      a {
        color: #383838;
        margin-left: 30px;
        &:hover {
          color: @primary-color;
        }
        img {
          margin: 0 10px 5px 0;
        }
      }
      // 操作指南按钮样式
      .guide-btn {
        display: inline-flex;
        align-items: center;
      }
    }
  }
}

.aizs {
  width: 60px;
  height: 110px;
  position: fixed;
  border-radius: 20px;
  top: 80vh;
  right: 40px;
  z-index: 9;
  background-color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  font-weight: 600;
  img {
    width: 45px;
    height: 45px;
    margin-top: 15px;
  }
}

.content-cover {
  height: calc(100% - 60px);
  overflow-y: auto;
  .content {
    height: 100%;
    background: #f9f9fc;
    .aside {
      min-height: 850px;
      height: 100%;
      position: relative;
      background: #fff;
      .tabs {
        width: @side-width;
        .tab {
          display: flex;
          justify-content: center;
          align-items: center;
          width: @side-width;
          height: @side-width;
          .cover {
            cursor: pointer;
            .img {
              width: 100px;
              height: 100px;
              border-radius: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .title {
              display: block;
              width: 100px;
              height: 40px;
              line-height: 40px;
              font-size: 16px;
              text-align: center;
              color: #383838;
            }
          }
        }
      }
      .userInfo {
        position: absolute;
        bottom: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: @side-width;
        .cover {
          .avatar {
            margin-bottom: 20px;
          }
          .name,
          .dep,
          .setting {
            width: 120px;
            text-align: center;
            margin-bottom: 20px;
          }
          .name {
            font-size: 16px;
            font-weight: 900;
          }
        }
      }
    }
    .setting-panel {
      background: #fff;
      position: absolute;
      right: -400px;
      bottom: 0;
      width: 400px;
      height: 450px;
      z-index: 100;
      padding: 30px;
      box-shadow: 0px 0px 9px #cccccc;
      transition: all 1s;

      .tip {
        display: flex;
        justify-content: space-between;
        img {
          width: 40px;
          height: 40px;
        }
        span {
          margin-left: 10px;
          margin-top: 10px;
          color: #383838;
        }
      }
    }
    .main {
      min-height: 850px;
      height: 100%;
      overflow-y: scroll;
      background: #202441;
      .cover {
        margin: 20px;
      }
    }
  }
}

// 操作指南弹窗样式
.guide-content {
  padding: 10px 0;

  .file-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
    &:last-of-type {
      border-bottom: none;
    }
  }

  .file-link {
    font-size: 16px;
    color: #1890ff;
    &:hover {
      color: #40a9ff;
      text-decoration: underline;
    }
  }

  .tips {
    margin-top: 20px;
    padding: 10px;
    background-color: #f7f7f7;
    border-radius: 4px;
    color: #666;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
